import React, { useMemo } from 'react';
import './BackgroundEffects.css';

interface Skull {
  id: number;
  left: string;
  delay: string;
  duration: string;
}

const SKULL_COUNT = 18;

export const BackgroundEffects: React.FC = () => {
  const skulls = useMemo<Skull[]>(() => {
    return Array.from({ length: SKULL_COUNT }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 12}s`,
      duration: `${8 + Math.random() * 7}s`,
    }));
  }, []);

  return (
    <div className="background-effects" aria-hidden="true">
      {skulls.map((skull) => (
        <div
          key={skull.id}
          className="falling-skull"
          style={{
            left: skull.left,
            animationDelay: skull.delay,
            animationDuration: skull.duration,
          }}
        >
          💀
        </div>
      ))}
    </div>
  );
};

export default BackgroundEffects;
